// extracted by mini-css-extract-plugin
module.exports = {"count":"IconCountBadge_count__x8dPJ","cluster":"IconCountBadge_cluster__mpP_r"};